
export const FlipPolygon = (coorArr) => coorArr.map(ele => [ele[1], ele[0]])